import React, { useState, useEffect, useReducer, createContext, Suspense } from "react";
import { motion } from "framer-motion";

import "../styles/FrontPage.scss"

function FrontPage() {
    return (
        <div className="frontpage">
            <div className="brand">
                <motion.div
                    initial={{opacity: 0, scale: 1, y: 20}}
                    animate={{opacity: 1, scale: 1, y: 0}}
                    transition={{ duration: 0.5, delay: 0}}
                    exit={{opacity: 0, scale: 0.9}}
                >
                    ANVIL
                </motion.div>
                
            </div>
            

        </div>
    );
}

export default FrontPage;